import React, { useEffect, useMemo } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { useGetJiraProjects } from '../JiraConnect.hooks';

export interface JiraProjectPickerProps {
  value?: string;
  disabled?: boolean;
  textFieldProps?: Omit<TextFieldProps, 'variant'>;
  onChange?: (id: string | undefined) => void;
}

const JiraProjectPicker: React.FC<JiraProjectPickerProps> = props => {
  const { value, disabled, textFieldProps, onChange } = props;
  const [{ data = [], isLoading, error }, getProjects] = useGetJiraProjects();

  const options = useMemo(() => {
    return data.map(project => ({
      value: project.id,
      label: `${project.name} (${project.key})`
    }));
  }, [data]);

  const selected = useMemo(() => {
    return value ? options.find(option => option.value === value) : undefined;
  }, [options, value]);

  useEffect(() => {
    getProjects();
  }, [getProjects]);

  return (
    <Autocomplete
      className='field'
      options={options}
      disabled={disabled}
      loading={isLoading}
      value={selected || null}
      getOptionLabel={option => option.label}
      onChange={(_, value) => onChange?.(value?.value)}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          variant='outlined'
          label='Select Project'
          error={!!error?.message}
          helperText={error?.message}
          {...textFieldProps}
          InputProps={{ ...params.InputProps, ...textFieldProps?.InputProps }}
        />
      )}
    />
  );
};

export default JiraProjectPicker;
